var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import styled from 'styled-components';
import * as _ from 'lodash';
import { observer, inject } from 'mobx-react';
import colors from '../utils/colors';
import { Table, TableCell, TableHead, TableHeadCell, TableRow, TableBody } from './BrandTable';
import { isSpaceTag, isTableTag } from '../types/floorplan';
import { BrandButtonSecondary, BrandButtonTertiary } from './BrandButton';
import constants from '../utils/constants';
import ImageOptions from './ImageOptions';
import { FloorImageContainer } from './FloorImageContainer';
import FloorImageContent from './FloorImageContent';
import EmployeeLists from './EmployeeLists';
import { Subtitle, Description, TextArea } from './BrandText';
import { ScrollableContainer, SCROLLBAR_WIDTH_CSS } from './ScrollableContainer';
import { Button, DialogActions, DialogTitle } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
var FloorPlanContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  background-color: ", ";\n  box-shadow: 0 6px 20px 4px ", ";\n"], ["\n  height: 100%;\n  background-color: ", ";\n  box-shadow: 0 6px 20px 4px ", ";\n"])), colors.WHITE, colors.TP_GRAY);
var PlanDivider = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 30px;\n  background-color: ", ";\n  height: 1px;\n  width: 100%;\n"], ["\n  margin-top: 30px;\n  background-color: ", ";\n  height: 1px;\n  width: 100%;\n"])), function (props) { return props.theme.supportingColorLight || colors.TP_TURQUOISE_DARK; });
var ContentWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: grid;\n  width: 100%;\n  height: 100%;\n  grid-template-columns: auto 360px;\n  grid-template-rows: 60px auto;\n  grid-template-areas:\n    'content-1 content-3'\n    'content-2 content-3';\n"], ["\n  display: grid;\n  width: 100%;\n  height: 100%;\n  grid-template-columns: auto 360px;\n  grid-template-rows: 60px auto;\n  grid-template-areas:\n    'content-1 content-3'\n    'content-2 content-3';\n"])));
var GriddedImageOptions = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  grid-area: content-1;\n  margin: 0 16px;\n"], ["\n  grid-area: content-1;\n  margin: 0 16px;\n"])));
var GriddedFloorImageContainer = styled(FloorImageContainer)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  grid-area: content-2;\n"], ["\n  grid-area: content-2;\n"])));
var ScrollableRight = styled(ScrollableContainer)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border-left: 1px solid ", ";\n  padding: 24px ", ";\n  grid-row: ", ";\n"], ["\n  border-left: 1px solid ", ";\n  padding: 24px ", ";\n  grid-row: ", ";\n"])), function (props) { return props.theme.supportingColorLight || colors.TP_TURQUOISE_DARK; }, SCROLLBAR_WIDTH_CSS, function (props) { return (props.isSpaceSelected ? '2' : '1 / -1'); });
var UploadButton = styled(BrandButtonTertiary)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: 280px;\n"], ["\n  width: 280px;\n"])));
var SidebarPaddingContainer = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin: 0px 10px;\n"], ["\n  margin: 0px 10px;\n"])));
var UploadMoreNamesWrapper = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  border-left: 1px solid ", ";\n"], ["\n  border-left: 1px solid ", ";\n"])), function (props) { return props.theme.supportingColorLight || colors.TP_TURQUOISE_DARK; });
var UploadMoreNamesButton = styled(BrandButtonSecondary)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  width: 200px;\n  margin: 22px 18px;\n  text-transform: uppercase;\n"], ["\n  width: 200px;\n  margin: 22px 18px;\n  text-transform: uppercase;\n"])));
var FileUploadLabel = styled.label(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: block;\n  padding-left: 16px;\n"], ["\n  display: block;\n  padding-left: 16px;\n"])));
var FileUploadInfo = styled.span(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  color: ", ";\n  display: inline-block;\n  text-transform: uppercase;\n"], ["\n  color: ", ";\n  display: inline-block;\n  text-transform: uppercase;\n"])), function (props) { return props.theme.primaryColor || colors.TP_TURQUOISE; });
var FileUploadName = styled.span(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  color: ", ";\n  padding-right: 16px;\n  display: inline-block;\n"], ["\n  color: ", ";\n  padding-right: 16px;\n  display: inline-block;\n"])), colors.TEXT_DEFAULT);
var FileUploadInput = styled.input(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
var ImportAssignmentButton = styled(BrandButtonTertiary)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  margin-top: 10px;\n"], ["\n  margin-top: 10px;\n"])));
var FloorPlanConnect = /** @class */ (function (_super) {
    __extends(FloorPlanConnect, _super);
    function FloorPlanConnect(props) {
        var _this = _super.call(this, props) || this;
        _this.floorImg = React.createRef();
        _this.updateFloor = function (selectedFloor) {
            _this.props.floorPlanStore.setCurrentFloor(selectedFloor);
        };
        _this.setZoomLevel = function (level) {
            _this.setState({ zoomLevel: level });
        };
        _this.handleImageClick = function () {
            _this.props.floorPlanStore.setSpaceSelection(null);
        };
        _this.handleMarkerClick = function (event, tag) {
            if (isSpaceTag(tag)) {
                _this.props.floorPlanStore.setSpaceSelection(tag);
            }
            if (isTableTag(tag)) {
                // In case we need an option to select table directly
            }
        };
        _this.handleRowSelection = function (owner) {
            if (_this.state.selectedOwner === owner) {
                _this.setState({ selectedOwner: null });
            }
            else {
                _this.setState({ selectedOwner: owner });
            }
        };
        _this.handleTextAreaChange = function (e) {
            _this.setState({
                names: e.target.value,
            });
        };
        _this.handleOnUploadMoreNamesClick = function () {
            _this.props.floorPlanStore.setSpaceSelection(null);
        };
        _this.uploadNames = function () {
            var submitNames = _this.state.names
                .split(/\r?\n/)
                .map(function (name) { return name.trim(); })
                .filter(function (name) { return name.length > 0; });
            _this.props.floorPlanStore.createOwner(submitNames);
            _this.setState({
                names: '',
            });
        };
        // Returns a table options for specific space.
        _this.getTableOptions = function (spaceTag) {
            var currentFloor = _this.props.floorPlanStore.currentFloor;
            if (!currentFloor || !spaceTag || !_this.props.spacesStore) {
                return [];
            }
            return _this.props.spacesStore.tableOptionsOnASpace(currentFloor, spaceTag, true, true);
        };
        _this.renderUploadMoreNamesView = function () { return (React.createElement(UploadMoreNamesWrapper, null,
            React.createElement(UploadMoreNamesButton, { onClick: _this.handleOnUploadMoreNamesClick }, "Upload more names"))); };
        _this.handleAssignmentFileChange = function (selectorFiles) {
            if (!_.isNil(selectorFiles) && !_.isNil(selectorFiles[0])) {
                var selectedFile = selectorFiles[0];
                _this.setAssignmentFile(selectedFile);
            }
        };
        _this.onImportAssignmentClicked = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({ isImportConfirmDialogOpened: true });
                return [2 /*return*/];
            });
        }); };
        _this.onImportCanceled = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({ isImportConfirmDialogOpened: false });
                return [2 /*return*/];
            });
        }); };
        _this.onImportConfirmed = function () { return __awaiter(_this, void 0, void 0, function () {
            var assignmentFileContent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ isImportConfirmDialogOpened: false });
                        return [4 /*yield*/, this.state.assignmentFile.text()];
                    case 1:
                        assignmentFileContent = _a.sent();
                        return [4 /*yield*/, this.props.floorPlanStore.importAssignments(assignmentFileContent)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.renderUploadNamesView = function () { return (React.createElement("div", null,
            React.createElement(Subtitle, null, "Import file"),
            React.createElement(FileUploadLabel, null,
                !_this.state.assignmentFile && React.createElement(FileUploadInfo, null, "Browse..."),
                React.createElement(FileUploadName, null, _this.state.assignmentFile && _this.state.assignmentFile.name),
                _this.state.assignmentFile && React.createElement(FileUploadInfo, null, "Change..."),
                React.createElement(FileUploadInput, { type: "file", accept: ".csv", onChange: function (e) { return _this.handleAssignmentFileChange(e.target.files); }, ref: function (ref) { return (_this.fileInput = ref); } }),
                _this.state.assignmentFile && (React.createElement(ImportAssignmentButton, { onClick: _this.onImportAssignmentClicked }, "Import people"))),
            React.createElement(Dialog, { open: _this.state.isImportConfirmDialogOpened },
                React.createElement(DialogTitle, null, "The file will replace the existing allocation of people. Will you continue to import people from the file?"),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { color: "secondary", onClick: _this.onImportCanceled }, "No"),
                    React.createElement(Button, { color: "primary", onClick: _this.onImportConfirmed }, "Yes"))),
            React.createElement(Subtitle, null, "Add a list of people"),
            React.createElement(Description, null, "Make marking the people easier by uploading a list of names to the system. Each name should be in the same format and separated by rows."),
            React.createElement(Table, { style: { width: '280px' } },
                React.createElement(TableHead, null,
                    React.createElement("tr", null,
                        React.createElement(TableHeadCell, null, "Names"))),
                React.createElement(TableBody, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { style: { padding: 0 } },
                            React.createElement(TextArea, { id: "story", name: "story", value: _this.state.names, onChange: _this.handleTextAreaChange }))))),
            React.createElement(UploadButton, { onClick: _this.uploadNames }, "Upload names"))); };
        _this.state = {
            selectedOwner: null,
            zoomLevel: constants.ZOOM_LEVEL_DEFAULT,
            names: '',
            submitNames: [],
            assignmentFile: null,
            isImportConfirmDialogOpened: false,
        };
        _this.fileInput = React.createRef();
        _this.handleRowSelection = _this.handleRowSelection.bind(_this);
        _this.handleImageClick = _this.handleImageClick.bind(_this);
        _this.handleMarkerClick = _this.handleMarkerClick.bind(_this);
        _this.updateFloor = _this.updateFloor.bind(_this);
        _this.setZoomLevel = _this.setZoomLevel.bind(_this);
        _this.handleTextAreaChange = _this.handleTextAreaChange.bind(_this);
        _this.uploadNames = _this.uploadNames.bind(_this);
        _this.setAssignmentFile = _this.setAssignmentFile.bind(_this);
        _this.handleAssignmentFileChange = _this.handleAssignmentFileChange.bind(_this);
        _this.onImportAssignmentClicked = _this.onImportAssignmentClicked.bind(_this);
        _this.onImportCanceled = _this.onImportCanceled.bind(_this);
        _this.onImportConfirmed = _this.onImportConfirmed.bind(_this);
        return _this;
    }
    FloorPlanConnect.prototype.setAssignmentFile = function (assignmentFile) {
        this.setState({ assignmentFile: assignmentFile });
    };
    FloorPlanConnect.prototype.render = function () {
        var _this = this;
        var _a = this.props.floorPlanStore, currentFloor = _a.currentFloor, tableTags = _a.tableTags, unAssignedOwners = _a.unAssignedOwners, assignedOwners = _a.assignedOwners, assignOwner = _a.assignOwner, assignOwnerWithName = _a.assignOwnerWithName, assignOwnerTable = _a.assignOwnerTable, returnOwner = _a.returnOwner, deleteOwner = _a.deleteOwner, spaceSelection = _a.spaceSelection, spaceAssignedOwners = _a.spaceAssignedOwners;
        var _b = this.state, zoomLevel = _b.zoomLevel, selectedOwner = _b.selectedOwner;
        var renameOwner = function (owner, space) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.floorPlanStore.renameOwner(owner, space)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        // currentFloor should never be null at this point
        if (!currentFloor || !this.props.spacesStore) {
            return null;
        }
        var spaceOptions = this.props.spacesStore.spaceOptionsOnAFloor(currentFloor, true);
        return (React.createElement(FloorPlanContainer, null,
            React.createElement(ContentWrapper, null,
                React.createElement(GriddedImageOptions, null,
                    React.createElement(ImageOptions, { onZoom: this.setZoomLevel, zoomLevel: zoomLevel, marginRight: "16px" })),
                React.createElement(GriddedFloorImageContainer, null,
                    React.createElement(FloorImageContent, { forwardedRef: this.floorImg, currentFloor: currentFloor, zoomLevel: zoomLevel, initialFit: "contain", tableTags: tableTags, onImageClick: this.handleImageClick, onMarkerClick: this.handleMarkerClick })),
                spaceSelection !== null && this.renderUploadMoreNamesView(),
                React.createElement(ScrollableRight, { isSpaceSelected: spaceSelection !== null },
                    React.createElement(SidebarPaddingContainer, null,
                        spaceSelection === null && this.renderUploadNamesView(),
                        spaceSelection !== null && React.createElement(Subtitle, null,
                            "Space ",
                            spaceSelection.title,
                            " selected")),
                    spaceSelection === null && React.createElement(PlanDivider, null),
                    React.createElement(EmployeeLists, { selectedOwner: selectedOwner, onOwnerSelect: this.handleRowSelection, assignedOwners: assignedOwners, unassignedOwners: unAssignedOwners, spaceAssignedOwners: spaceAssignedOwners, spaceOptions: spaceOptions, getTableOptions: this.getTableOptions, spaceSelected: spaceSelection, onSpaceSelected: assignOwner, onSpaceOptionSelected: assignOwnerWithName, onTableSelected: assignOwnerTable, onOwnerReturn: returnOwner, onOwnerRemove: deleteOwner, onOwnerRename: renameOwner })))));
    };
    FloorPlanConnect = __decorate([
        inject('spacesStore'),
        observer
    ], FloorPlanConnect);
    return FloorPlanConnect;
}(Component));
export default FloorPlanConnect;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;
//# sourceMappingURL=FloorPlanConnect.js.map